module.exports = __webpack_public_path__ + "img/result4.b4674ac7.png";